// extracted by mini-css-extract-plugin
export var container = "_cj-0";
export var icon = "_cj-1";
export var text = "_cj-2";